import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import {
  DEFAULT_EMPTY_VALUE,
  DIRECTORS,
  DIRECTOR_COLUMNS,
  FORMER_DIRECTORS,
  PROVIDER_SOURCES,
} from 'src/constants/companyReport';
import { formatDate, getMatchByName, combineNames } from 'src/services/companyReportDetail.service';
import LikelyHood from '../LikelyHood';

interface Props {
  activeIndex: string;
  handleOnClick: (index: string) => void;
  detailData: any;
  allScreenedEntities: any;
}

const Director = ({ activeIndex, handleOnClick, detailData, allScreenedEntities }: Props) => {
  const directors =
    detailData.companyProfile?.companyProfile?.directorAndShareDetails?.directors ?? [];
  const formerDirectors =
    detailData.companyProfile?.companyProfile?.directorAndShareDetails?.formerDirectors ?? [];

  return (
    <div className={`card accordion ${activeIndex === 'directors' ? 'active' : ''}`}>
      <div className="accordion-heading" onClick={() => handleOnClick('directors')}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-4 align-items-center">
            <h4 className="mb-0">
              DIRECTORS <span> ({directors.length})</span>
            </h4>
          </div>
          <div>
            <img
              className="chevron-icon"
              src={require('src/assets/images/icons/chevron-down.svg').default}
              alt="chevron-down icon"
            />
          </div>
        </div>
      </div>
      <div className="accordion-content">
        {detailData.source === PROVIDER_SOURCES.CREDITSAFE ? (
          <CreditsafeDirector
            directors={directors}
            formerDirectors={formerDirectors}
            allScreenedEntities={allScreenedEntities}
          />
        ) : (
          <DefaultDirector directors={directors} allScreenedEntities={allScreenedEntities} />
        )}
      </div>
    </div>
  );
};

const CreditsafeDirector = ({ directors, formerDirectors, allScreenedEntities }: any) => {
  return (
    <Tabs>
      <TabList>
        <Tab>{DIRECTORS}</Tab>
        <Tab>{FORMER_DIRECTORS}</Tab>
      </TabList>
      <TabPanel>
        <DefaultDirector directors={directors} allScreenedEntities={allScreenedEntities} />
      </TabPanel>
      <TabPanel>
        <DefaultDirector directors={formerDirectors} allScreenedEntities={allScreenedEntities} />
      </TabPanel>
    </Tabs>
  );
};

const DefaultDirector = ({ directors, allScreenedEntities }: any) => {
  return (
    <div className="mt-3">
      <table className="accordion-table sm-th-md-td">
        <thead>
          <tr>
            <th>{DIRECTOR_COLUMNS.name}</th>
            <th>{DIRECTOR_COLUMNS.match}</th>
            <th>{DIRECTOR_COLUMNS.dateOfBirth}</th>
            <th>{DIRECTOR_COLUMNS.position}</th>
            <th>{DIRECTOR_COLUMNS.dateAppointed}</th>
            <th>{DIRECTOR_COLUMNS.nationality}</th>
            <th>{DIRECTOR_COLUMNS.address}</th>
          </tr>
        </thead>
        <tbody>
          {directors.map((director: any, index: number) => (
            <tr key={director.id + director.name + index}>
              <td>{director.name ?? DEFAULT_EMPTY_VALUE}</td>
              <td>
                <LikelyHood match={getMatchByName(combineNames(director), allScreenedEntities)} />
              </td>
              <td>{formatDate(director.dateOfBirth)}</td>
              <td>{director.position ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{formatDate(director.dateAppointed)}</td>
              <td>{director.nationality ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{director.address ?? DEFAULT_EMPTY_VALUE}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Director;
